import React from "react";
export default function LoadingState({label="Carregando..."}){return <div role="status" className="p-8 text-center text-sm text-gray-500">{label}</div>}
